export default "__VITE_ASSET__CLLxlnlR__"